import { ReactNode, useState } from 'react';
import { AccessSource, EmployeeType } from '@prisma/client';
import { SelectProps, Spin } from 'antd';
import { debounce } from 'lodash';

import { EmployeeTypeRenderer } from '../../../../../common';
import { useFindAgsAccesses } from '../../../../access/data';

export const RoleLabelRenderer = ({
  children,
  employeeType,
}: {
  children: ReactNode;
  employeeType?: EmployeeType | null;
}) => (
  <div style={{ display: 'flex' }}>
    {children}
    <span style={{ marginLeft: 'auto' }}>
      <EmployeeTypeRenderer employeeType={employeeType} />
    </span>
  </div>
);

export const useAgsRolePicker = () => {
  const [search, setSearch] = useState('');
  const { data, isFetching, isPending } = useFindAgsAccesses(AccessSource.AGS_ROLE, {
    name: search,
    count: 100,
    requestableByWebService: true,
  });

  const options = data?.data.map((x) => ({
    ...x,
    key: x.externalId,
    value: x.externalId,
    label: <RoleLabelRenderer employeeType={x.employeeType}>{x.name}</RoleLabelRenderer>,
  }));

  const getSelectProps = (
    props?: Omit<
      SelectProps,
      'labelInValue' | 'loading' | 'mode' | 'notFoundContent' | 'options' | 'showSearch' | 'onSearch'
    >,
  ) => ({
    allowClear: true,
    filterOption: false,
    labelInValue: true,
    loading: isFetching || isPending,
    notFoundContent: isFetching || isPending ? <Spin size="small" /> : null,
    options,
    placeholder: 'Search by role name...',
    showSearch: true,
    onSearch: debounce(setSearch, 300),
    ...props,
  });

  return { getSelectProps };
};
